<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchCategory({ categoryId: '', categoryName: '全部' })"
              :class="{ 'selected': productManageInfo.conditions.categoryId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in productManageInfo.productCategorys" :key="index"
              @click="swatchCategory(item)"
              :class="{ 'selected': productManageInfo.conditions.categoryId == item.categoryId }">
              {{ item.categoryName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                placeholder="请输入商品名称"
                v-model="productManageInfo.conditions.prodName"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.state"
                placeholder="请选择状态"
                style="width:200px"
              >
                <el-option label="请选择状态" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.states"
                  :key="index"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.shId"
                placeholder="请选择仓库"
                style="width:200px"
              >
                <el-option label="请选择仓库" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.shopHouses"
                  :key="index"
                  :label="item.shName"
                  :value="item.shId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.hktId"
                placeholder="请选择手机菜单"
                style="width:200px"
              >
                <el-option label="请选择手机菜单" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.housekeepingTypes"
                  :key="index"
                  :label="item.hktName"
                  :value="item.hktId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryProductMethod()" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="_resetProductMethod()" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>商品信息</span>
            <div>
              <el-button type="primary" @click="_openAddProductModal()" icon="el-icon-plus">添加商品</el-button>
              <el-button type="primary" @click="_exportProduct()">导出</el-button>
            </div>
          </div>
          <el-table
            :data="productManageInfo.products"
            style="width: 100%"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column prop="productId" label="商品ID" align="center" />
            <el-table-column label="商品图片" align="center">
              <template #default="{row}">
                <el-image
                  style="width: 50px; height: 50px; border-radius: 10px;"
                  :src="row.coverPhoto"
                  :preview-src-list="[row.coverPhoto]"
                >
                  <div slot="error" class="image-slot">
                    <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" label="商品分组" align="center" />
            <el-table-column prop="prodName" label="商品名称" align="center" />
            <el-table-column prop="shName" label="仓库" align="center" />
            <el-table-column prop="sales" label="销量" align="center" />
            <el-table-column prop="stock" label="库存" align="center" />
            <el-table-column prop="defaultSpecValue.price" label="价格" align="center" />
            <el-table-column prop="sort" label="排序" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center" width="300">
              <template #default="{row}">
                <el-button-group>
                  <el-button size="mini" @click="_viewProductQrcode(row)">查看</el-button>
                  <el-button size="mini" @click="_openEditProductModel(row)">修改</el-button>
                  <el-button size="mini" @click="_openDeleteProductModel(row)">删除</el-button>
                  <el-button size="mini" @click="_openProductLabelModel(row)">打标</el-button>
                  <el-button size="mini" @click="_openProductDetail(row)">详情</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="productManageInfo.conditions.page"
            :page-size="productManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="productManageInfo.total"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct" @refresh="_listProducts"></delete-product>
    <choose-product-spec ref="chooseProductSpec" @refresh="_listProducts"></choose-product-spec>
    <add-product-label ref="addProductLabel"></add-product-label>
    <view-qrcode ref="viewQrcode" @refresh="_listProducts"></view-qrcode>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryProduct, queryProductCategory, queryShopHouse, queryHousekeepingType, exportData } from '@/api/goods/productApi'
import DeleteProduct from '@/components/goods/deleteProduct/deleteProduct'
import ChooseProductSpec from '@/components/goods/chooseProductSpec/chooseProductSpec'
import AddProductLabel from '@/components/goods/addProductLabel/addProductLabel'
import viewQrcode from '@/components/system/viewQrcode'

export default {
  name: 'ProductManage',
  components: {
    DeleteProduct,
    ChooseProductSpec,
    AddProductLabel,
    viewQrcode
  },
  data() {
    return {
      loading: false,
      productManageInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        states: [],
        conditions: {
          categoryId: '',
          state: '',
          prodName: '',
          keyword: '',
          barCode: '',
          shopId: '',
          shId: '',
          hktId: '',
          page: 1,
          row: 10
        },
        productCategorys: [],
        shopHouses: [],
        housekeepingTypes: []
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = await getShopId();
      this.productManageInfo.conditions.shopId = shopId
      await this._listProducts()
      await this._listHousekeepingTypes()
      await this._listProductCategorys()
      await this._listShopHouses()
      this._getDictData()
    },
    async _getDictData() {
      try {
        const {data} = await getDict('product', 'state')
        this.productManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listProducts() {
      this.loading = true
      try {
        const params = { ...this.productManageInfo.conditions }
        params.prodName = params.prodName.trim()
        const res = await queryProduct(params)
        this.productManageInfo.total = res.total
        this.productManageInfo.records = res.records
        this.productManageInfo.products = res.data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    async _listProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.productManageInfo.conditions.shopId
        }
        const res = await queryProductCategory(params)
        this.productManageInfo.productCategorys = res.data
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },
    _openAddProductModal() {
      this.$router.push('/pages/goods/addProduct')
    },
    _openEditProductModel(product) {
      this.$router.push(`/pages/goods/editProduct?productId=${product.productId}`)
    },
    _openDeleteProductModel(product) {
      this.$refs.deleteProduct.open(product)
    },
    _openProductDetail(product) {
      window.open(`/#/pages/goods/productDetail?productId=${product.productId}`)
    },
    _queryProductMethod() {
      this.productManageInfo.conditions.page = 1
      this._listProducts()
    },
    _resetProductMethod() {
      this.productManageInfo.conditions.prodName = ''
      this.productManageInfo.conditions.categoryId = ''
      this.productManageInfo.conditions.state = ''
      this._listProducts()
    },
    async _listShopHouses() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.productManageInfo.conditions.shopId
        }
        const res = await queryShopHouse(params)
        this.productManageInfo.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    async _listHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 30,
          typeCd: '2002',
          shopId: '9999',
          skipType: '3'
        }
        const res = await queryHousekeepingType(params)
        this.productManageInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取手机菜单失败:', error)
      }
    },
    _openProductLabelModel(product) {
      this.$refs.addProductLabel.open(product)
    },
    _viewProductQrcode(product) {
      this.$refs.viewQrcode.open({
        qrcodeName: product.prodName,
        qrCodeUrl: product.pageUrl,
        remark: `手机扫码查看商品${product.pageUrl}`
      })
    },
    swatchCategory(catalog) {
      this.productManageInfo.conditions.categoryId = catalog.categoryId
      this._listProducts()
    },
    async _exportProduct() {
      try {
        this.productManageInfo.conditions.pagePath = 'storeProductManage'
        const res = await exportData(this.productManageInfo.conditions)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心&fileType=storeProductManage')
        }
      } catch (error) {
        console.error('导出失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.productManageInfo.conditions.page = val
      this._listProducts()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>